module.exports = __webpack_public_path__ + "static/media/icon-maximize-2.8ccdd199.svg";